import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';

import { AppState } from '../../../../store/app-state';
import { uiToggleMainBarAction } from '../../../../store/ui/index';
import { userLogoutAction } from '../../../../store/user/index';
import { AccountService } from '../../../service/app/account.service';
import { RouterService } from '../../../service/core/router.sevice';
import { DialogService } from 'ng2-bootstrap-modal';
import { TestModalComponent } from '../../modal/test.modal';
import { LoginModalComponent } from '../../modal/login.modal';
import { CommerceService } from 'app/core/service/app/commerce.service';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit, OnDestroy {
  logo;
  isAuth = false;
  correo = '';
  titulo = 'proceso de registro';
  destroy = new Subject();

  constructor(
    private store: Store<AppState>,
    private routerService: RouterService,
    private accountService: AccountService,
    private commerce: CommerceService,
    private dialogService: DialogService
  ) {
    this.store.subscribe(state => {
      //this.logo = state.static.logo['white'];
      
      this.isAuth = state.user.isAuth;
      if (state.user.data) {
        this.correo = state.user.data.email;
      }
    });

    this.commerce.titulo
      //.takeUntil(this.destroy)
      .subscribe(result => (this.titulo = result));
  }

  login() {
    let disposable = this.dialogService
      .addDialog(
        LoginModalComponent,
        {
          data: {}
        },
        { backdropColor: 'rgba(150, 150, 150, 0.5)' }
      )
      .subscribe(email => {
        this.correo = email || '';
      });
  }

  ngOnInit() {}

  toggleMainbar() {
    this.store.dispatch(uiToggleMainBarAction());
  }

  login2() {
    this.routerService.go('/account');
  }

  register() {
    this.routerService.go('/account/register');
  }

  logout() {
    setTimeout(() => {
      this.accountService.logut();
    }, 1000);
  }

  ngOnDestroy() {
    this.destroy.next();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/component/ui/topbar/topbar.component.ts